import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { DataStateChangeEventArgs, GridComponent } from '@syncfusion/ej2-angular-grids';
import { PageSettingsModel, TextWrapSettingsModel } from '@syncfusion/ej2-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';
import { GetBO } from '../pages.modal';
import { ActiveSessionService } from './active-session.service';
@Component({
    selector: 'app-active-session',
    templateUrl: './active-session.component.html',
    styleUrls: ['./active-session.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ActiveSessionComponent implements OnInit {
    @ViewChild('gridactivesession') public gridactivesession: GridComponent;

    ActiveSessionList: any;

    ActiveBo: GetBO = new GetBO();    
    private onDestroy$: Subject<void> = new Subject<void>();

    public GridList: Observable<DataStateChangeEventArgs>;
    public wrapSettings: TextWrapSettingsModel;    
    public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
    initialPage: PageSettingsModel;

    constructor(public http: HttpClient, public global: GlobalComponent,
        public toasterService: ToastrService, public general: GeneralService, private router: Router,
        public dateservice: DateService, public ActiveService: ActiveSessionService
    ) {
        this.GridList = ActiveService;
        this.global.checkforlogout();
    }
    ngOnInit(): void {
        this.wrapSettings = { wrapMode: 'Content' };
        this.getActiveFilter();
        this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
      }
    //.......................... getActiveFilter...........................................
    getActiveFilter() {
        this.ActiveBo.field = "loginIp";
        this.ActiveBo.orderColumn = "loginIp";
        this.ActiveService.execute(this.ActiveBo);
        let count = 0;
        this.GridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
            count = count + 1;
            if (data != null && data.result.length > 15) {
                this.gridactivesession.height = '500';
            }
            else {
                this.gridactivesession.height = 'auto';
            }
        })
    }

    // ................................................dataChangeAs..............................................
    public dataChangeAs(As): void {
        let val = (As.action.requestType).toString();
        if (val != "filterchoicerequest") {
            if ((As.sorted || []).length) {
                this.ActiveBo.orderColumn = As.sorted[0].name;
                this.ActiveBo.orderType = As.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
            }
        }
        if (val == "filtering" && As.action.action != "clearFilter") {
            this.ActiveBo.value = As.action.currentFilterObject.value;
            this.ActiveBo.field = As.action.currentFilterObject.field;
            this.ActiveBo.matchCase = As.action.currentFilterObject.matchCase;
            this.ActiveBo.operator = As.action.currentFilterObject.operator;
        }
        else {
            if (val == "filtering" && As.action.action == "clearFilter") {
                this.ActiveBo.field = "loginIp";
                this.ActiveBo.matchCase = false;
                this.ActiveBo.operator = "contains";
                this.ActiveBo.value = "";
                this.ActiveBo.type = "string";
            }
        }
        this.getActiveFilter();
        if (val == "paging" && As.action.name == "actionBegin") {

        }
    }
    //.........................................onActionAs.....................................................
    public onActionAs(As) {
        this.ActiveBo.currentpageno = this.gridactivesession.pagerModule.pagerObj.currentPage;
        this.ActiveBo.pageitem = this.gridactivesession.pagerModule.pagerObj.pageSize;
        if (As.name == "actionBegin" && As.requestType == "filterbeforeopen") {
            this.ActiveBo.type = As.columnType
        }
    }

    revokeSessions(List) {
        this.ActiveService.revokeSessions([List.id]).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
            this.toasterService.success("Session Revoked SuccessFully!")
            this.getActiveFilter();
            setTimeout(() => {
                this.toasterService.clear();
            }, 8000);
        },
            (err: any) => {
                this.toasterService.error(err, 'error');
                setTimeout(() => {
                    this.toasterService.clear();
                }, 8000);
            })
    }

    backToOperationalDashboard() {
        this.router.navigateByUrl("/operational-dashboard");
    }
    
    public ngOnDestroy(): void {
        this.onDestroy$.next();
    }
}
